"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
exports.__esModule = true;
var styled_components_1 = require("styled-components");
var StyledDiv = styled_components_1["default"].div;
var ChartContainer = StyledDiv(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position :relative;\n  text-align: center;\n"], ["\n  position :relative;\n  text-align: center;\n"])));
exports["default"] = ChartContainer;
var templateObject_1;
